import React, { useMemo } from 'react';
import { CreditCard, Clock, ChevronRight } from 'react-feather';

import Styles from './Subscriptions.module.scss';

import { formatPrice } from '../../../../helpers/function/format';

const T_PREFIX = 'subscriptionsScreen.card';

const SubscriptionCard = ({ subscription, onSelectSubscription, t }) => {
    const { price, hide_price: isHidePrice } = subscription ?? {};
    const isShowPrice = !(isHidePrice === true && Number(price) === 0);

    const badge = useMemo(() => {
        if (subscription.client_subscription_is_active === false) {
            return (
                <div className={Styles.pendingStatus}>{t('subscriptionsScreen.pendingStatus')}</div>
            );
        } else if (subscription.client_subscription_is_active){
            if (subscription.paused) {
                return (
                    <div className={Styles.pauseStatus}>{t(`${T_PREFIX}.status.statuses.paused`)}</div>
                );
            } else {
                if (subscription.client_subscription_status === 'open') {
                    return (
                        <div className={Styles.unpaidStatus}>{t('subscriptionsScreen.unpaidStatus')}</div>
                    );
                }

                return (
                    <div className={Styles.boughtStatus}>{t('subscriptionsScreen.boughtStatus')}</div>
                )
            }
        }
    }, [
        subscription.client_subscription_is_active,
        subscription.paused,
        subscription.client_subscription_status,
        t,
    ])
    
    return (
        <div className={Styles.cardWrapper} onClick={() => onSelectSubscription(subscription)}>
            <div className={Styles.itemsWrapper}>
                <div className={Styles.itemNameWrapper}>
                    <div className={Styles.title}>{subscription.name}</div>
                    {badge}
                </div>
                <div className={Styles.infoWrapper}>
                    {isShowPrice && (
                        <div className={Styles.infoItem}>
                            <span className={Styles.icon}>
                                <CreditCard />
                            </span>
                            <span className={Styles.text} >
                               {formatPrice(subscription.price)}
                            </span>
                        </div>
                    )}
                    <div className={Styles.infoItem}>
                        <span className={Styles.icon}>
                            <Clock />
                        </span>
                        <span className={Styles.text}>
                            {t(`subscriptionsScreen.duration.${subscription.periodicity}`, {count: subscription.duration})}
                        </span>
                    </div>

                </div>
            </div>
            <ChevronRight
                className={Styles.arrow}
                size={28}
            />
        </div>
)}

export default SubscriptionCard;
